import React from 'react';

import { HeaderLogo } from "./LogoStyling";

import logo from "../../images/Logo.svg";

const Logo = () => {
  return (
      <>
        <img src={logo} alt="logoImage" style={HeaderLogo} />
      </>
  )
}

export default Logo